// extracted by mini-css-extract-plugin
module.exports = {"unsupported":"VideoEmbed_unsupported__NLXC1"};